<template>
  <section class="contact-area pb-90">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-box">
            <h3 class="title mb-4">订单</h3>
            <div v-if="orders.length > 0" class="manuscript-list">
              <template v-for="(item, index) in orders">
                <div 
                  :class="index === 0 ? 'pb-4' : 'py-4'" 
                  :key="item.id ?? index"
                  :style="{ borderBottom: '1px solid #e1e7f2' }"
                >
                  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div class="flex-1">
                      <!-- 核心修改：优先显示匹配的稿件title，无则显示fullname或默认值 -->
                      <div class="flex justify-between items-center">
                        <h4 class="text-lg font-semibold mb-2">{{ getManuscriptTitle(item.refid) || item.subject || '' }}</h4>
                        <div style="padding-left: 12px; padding-bottom: 12px;">
                          <!-- 订单状态标签展示 -->
                          <template v-if="item.refundstatus > 0">
                            <el-tag size="mini" type="danger" v-if="item.refundstatus == 100">已退款</el-tag>
                            <el-tag size="mini" type="" effect="dark" v-else-if="item.refundstatus == 50">
                              <i class="el-icon-loading"></i> 退款中
                            </el-tag>
                            <el-tag size="mini" type="purple" v-else-if="item.refundstatus == 90">退款失败</el-tag>
                            <el-tag size="mini" type="info" v-else-if="item.refundstatus == 80">退款关闭</el-tag>
                          </template>
                          <template v-else>
                            <el-tag size="mini" type="danger" v-if="item.status == -90">已退款</el-tag>
                            <el-tag size="mini" type="info" v-else-if="item.status == -20">已过期</el-tag>
                            <el-tag size="mini" type="info" v-else-if="item.status == -50">已取消</el-tag>
                            <el-tag size="mini" type="info" v-else-if="item.status == -10">已作废</el-tag>
                            <el-tag size="mini" type="danger" v-else-if="item.status == -100">已删除</el-tag>
                            <el-tag size="mini" type="success" v-else-if="item.paystatus == 99">免费</el-tag>
                            <el-tag size="mini" type="success" v-else-if="item.paystatus == 100">已付款</el-tag>
                            <el-tag size="mini" type="" effect="dark" v-else-if="item.paystatus == 50">转账待确认</el-tag>
                            <template v-else>
                              <el-tag size="mini" type="primary" v-if="item.paysource == 1">当面付</el-tag>
                              <el-tag size="mini" type="info" v-else-if="item.expiretime && item.expiretime < Math.floor(Date.now() / 1000)">已过期</el-tag>
                              <el-tag size="mini" type="" effect="dark" v-else>待付款</el-tag>
                            </template>
                          </template>
                        </div>
                      </div>
                      <div class="text-gray-600 space-y-1">
                        <p>订单号：{{ item.tradeno }}</p>
                        <p>
                          订单金额：<span class="text-red-500 font-medium">¥{{ formatPrice(item.amount) }}</span>
                          &nbsp;&nbsp;
                          实际支付：<span class="text-red-500 font-medium">¥{{ formatPrice(item.payamount) }}</span>
                        </p>
                        <p>支付时间：{{ formatTime(item.paytime) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-else class="text-gray-500 text-center py-8">
              <p>暂无订单</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { 
  getMeOrders,
  getMeManuscripts
} from '@/api/user';
import { 
  formatTimestampToDateTime
 } from '@/utils/dateUtil';

export default {
  components: {},
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      orders: [],
      manuscripts: [], // 新增：存储所有稿件数据
      events: [],
      darkClass: {},
      type: Number(this.$route.query.type) || 0
    }
  },
  created() {
    // 先获取稿件数据，再获取订单数据
    this.getManuscripts().then(() => {
      this.getOrders();
    });
  },
  methods: {
    // 新增：获取所有稿件数据
    async getManuscripts() {
      try {
        const res = await getMeManuscripts();
        if (res.code === 200) {
          this.manuscripts = res.list || []; // 存储稿件列表
          console.log('获取稿件数据成功:', this.manuscripts);
        } else {
          this.$message?.error(res.err || '获取稿件数据失败');
        }
      } catch (error) {
        this.$message?.error('网络异常，获取稿件数据失败');
        console.error('获取稿件接口异常：', error);
      }
    },
    async getOrders() {
      try {
        const res = await getMeOrders({
          filter: {
            validstatus: true,
            type:4,
          },
        });
        if (res.code === 200) {
          this.orders = res.list || [];
          console.log('getMeOrders res:', this.orders);
        } else {
          this.$message?.error(res.err || '获取项目失败');
        }
      } catch (error) {
        this.$message?.error('网络异常，获取项目失败');
        console.error('获取项目接口异常：', error);
      }
    },
    // 新增：根据refid匹配稿件title
    getManuscriptTitle(refid) {
      if (!refid || !this.manuscripts.length) return '';
      console.log('refid:',refid);
      console.log('man:', this.manuscripts);
      // 查找refid等于稿件id的记录
      const targetManuscript = this.manuscripts.find(ms => ms.id === refid);
      // 返回匹配的title，无则返回空
      return targetManuscript?.title || '';
    },
    /** 价格格式化：保留2位小数，空值展示0.00 */
    formatPrice(price) {
      const val = Number(price)/100 || 0;
      return val.toFixed(2);
    },
    /** 时间格式化：处理时间戳/标准时间格式，空值展示未支付 */
    formatTime(timestamp) {
      if (!timestamp) return '未支付';
      const time = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
      return formatTimestampToDateTime(time) || '';
    },
  }
};
</script>

<style scoped>
.contact-box {
  /* background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08); */
}
.manuscript-list {
  margin-top: 16px;
}
/* 移除最后一项的底部边框，避免多余横线 */
.manuscript-list > div:last-child {
  border-bottom: none !important;
}
</style>